"use client"

import { FolderId, MenuId } from "./types"
import { FOLDER_LABELS } from "./data"
import Win95Button from "./Win95Button"

const FOLDER_ICONS: Record<FolderId, string> = {
	inbox: "📥",
	spam: "🚫",
	sent: "📤",
	trash: "🗑️",
}

type FolderMenuProps = {
	selected: MenuId
	onSelect: (menuItem: MenuId) => void
}

export default function FolderMenu({ selected, onSelect }: FolderMenuProps) {
	const folders = Object.keys(FOLDER_LABELS) as FolderId[]

	return (
		<div
			className="
				w-[10rem] shrink-0
				max-sm:portrait:w-full max-sm:portrait:shrink-0
				bg-[#0a0015]
				border-2 border-t-[#ff6f00] border-l-[#ff6f00] border-b-[#bf00ff] border-r-[#bf00ff]
				p-2
				flex flex-col gap-2
				max-sm:portrait:flex-row max-sm:portrait:gap-1 max-sm:portrait:flex-wrap
			"
		>
			{folders.map((folder) => (
				<div key={folder} className="max-sm:portrait:flex-1 max-sm:portrait:min-w-0">
					<Win95Button
						label={FOLDER_LABELS[folder]}
						icon={FOLDER_ICONS[folder]}
						active={selected === folder}
						onClick={() => onSelect(folder)}
					/>
				</div>
			))}
			<div className="max-sm:portrait:flex-1 max-sm:portrait:min-w-0">
				<Win95Button
					label="Chat"
					icon="💬"
					active={selected === "chat"}
					onClick={() => onSelect("chat")}
				/>
			</div>
		</div>
	)
}
